<template>
  <grid
    html-tag="figure"
    :layout="[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        rows: 'repeat(1, auto)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        rows: 'repeat(1, auto)',
        gap: '10px',
      },
    ]"
    :class="[name, { video: video }]"
    :style="mainCssVars"
  >
    <grid-item
      :class="[`${name}__grid-item`, `${name}__media`]"
      :layout="[
        { size: 1, x: 1, width: 12, y: 1, height: 1 },
        { size: 3, x: 1, width: 24, y: 1, height: 1 },
      ]"
    >
      <transition name="fade">
        <m-media
          :cms="cms"
          :layout="[
            { size: 0, bound: 667, ratio: [375, 667] },
            { size: 1, bound: 768, ratio: [1480, 833] },
            { size: 2, bound: 992, ratio: [1480, 833] },
            { size: 3, bound: 1200, ratio: [1480, 833] },
            { size: 4, bound: 1440, ratio: [1480, 833] },
          ]"
          @has-video="hasVideo"
        />
      </transition>
    </grid-item>
  </grid>
</template>

<script>
import Colors from '~/mixins/colors'
import MMedia from '~/components/molecules/m-media/m-media'
export default {
  components: { MMedia },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      name: 'm-slide-v2',
      show: true,
      loaded: false,
      video: false,
    }
  },
  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || 'inherit',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || 'inherit'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || 'inherit'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || 'inherit'
        ),
        '--filter': this.cms.filter || null,
      }
    },
  },
  methods: {
    showContent(value) {
      this.show = value
    },
    hasVideo(value) {
      this.video = value
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-slide-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  display: grid;
  position: relative;
  vertical-align: top;
  margin: 0;
  height: 100%;
  overflow: hidden;

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep img {
    filter: var(--filter);
  }

  &:focus {
    outline: none;
  }

  &__media {
    //height: inherit;
    min-height: 693px;
    max-height: 820px;

    ::v-deep picture,
    ::v-deep img {
      height: 100%;
      width: 100%;
      min-height: inherit;
      display: inline-block;
      object-fit: cover;
    }
  }

  &.video &__caption {
    pointer-events: none;

    ::v-deep .a-link-v2,
    ::v-deep .link,
    ::v-deep a {
      pointer-events: initial;
    }
  }

  &__caption {
    align-self: end;
    z-index: 1;
  }

  &__eyebrow {
    @include font-size(18, 25.2px);
  }

  &__heading {
    @include font-family($headings-font-family, 600);
    @include font-size(36, 40.8px);

    text-shadow: 0 0 0.1em rgba(0, 0, 0, 0.2);
    margin: 0 0 35px;
    letter-spacing: 1px;
  }

  &__text {
    @include font-size(18, 25.2px);

    margin-bottom: 40px;
    letter-spacing: 1px;
  }

  &__cta {
    margin-bottom: 30px;
  }
}

@include media-breakpoint-up(sm) {
  .m-slide-v2 {
    &__cta {
      margin-right: 40px;
    }
  }
}

@include media-breakpoint-up(md) {
  .m-slide-v2 {
    &__caption {
      align-self: center;
    }
    &__heading {
      @include font-size(65, 78px);
    }
  }
}

@include media-breakpoint-up(lg) {
  .m-slide-v2 {
    &__heading {
      @include font-size(83, 96px);
    }
  }
}

@include media-breakpoint-up(xl) {
  .m-slide-v2 {
    &__heading {
      @include font-size(105, 124px);
    }
  }
}
</style>
